<template>
  <v-dialog
    v-model="showModal"
    max-width="600"
  >
    <v-card
      outlined
      color="#ECEFF1"
    >
      <br>
      <h2 class="title-style">
        <v-icon class="icon-style">
          mdi-pencil
        </v-icon>Edit Role
      </h2>
      <form>
        <v-container>
          <v-row
            class="fill-height"
            align-content="center"
            justify="center"
          >
            <v-col
              cols="12"
              md="8"
            >
              <v-card-text class="text-body-1 text-center">
                <p class="my-p-style">
                  Please select a role to Assign
                </p>
                <br>
                <v-autocomplete
                  v-model="roleId"
                  menu-props="auto"
                  :items="roleList"
                  item-value="id"
                  item-text="name"
                  label="Select Role"
                  dense
                  outlined
                  single-line
                />
              </v-card-text>
            </v-col>
          </v-row>
          <v-card-actions>
            <v-btn
              class="mt-2"
              color="red darken-3"
              @click="showModal = false"
            >
              cancel
            </v-btn>
            <v-spacer />
            <v-btn
              class="mt-2"
              color="#FF3700"
              :disabled="!isRoleSelected"
              @click="UpdateRole()"
            >
              Update
            </v-btn>
          </v-card-actions>
        </v-container>
      </form>
    </v-card>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
  import Constants from 'src/constants';
  import spinner from 'src/views/dashboard/component/SpinnerCentre';

  export default {
    name: 'EditRole',
    components: {
      'centre-spinner': spinner,
    },
    props: {
      role: {
        type: String,
        default: null,
      },
      userid: {
        type: String,
        default: null,
        requires: true,
      },
    },
    data () {
      return {
        showModal: true,
        roleId: '',
        loading: false,

      };
    },
    computed: {
      roleList () {
        return this.$store.getters['accountcontrol/getRolesAndPermissionsList'];
      },
      isRoleSelected () {
        return this.roleId !== '';
      },
    },
    watch: {
      showModal: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    async mounted () {
      this.loading = true;
      this.roleId = this.role;
      await this.$store.dispatch('accountcontrol/fetchRolesAndPermissionsList');
      this.loading = false;
    },
    methods: {
      UpdateRole () {
        this.$store.dispatch('users/updateUserRole', {
          user_id: this.userid,
          role_id: this.roleId,
        }).then(response => {
          this.$store.dispatch('alert/onAlert', {
            message: 'Role updated successfully.',
            type: Constants.ALERT_TYPE_SUCCESS,
          });
          this.$store.dispatch('users/fetchUsersList');
          this.showModal = false;
        }).catch(() => {
          this.loading = false;
        });
      },

    },
  };
</script>
<style scoped>
.title-style {
  color: #37474F;
  margin-left: 30px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.my-p-style {
  font-size: 18px;
  font-weight: bold;
  color: #546E7A;
  font-family:Cambria, Cochin, Georgia, Times, 'Times New Roman', serif;
  text-align: center;
}
</style>
